export const EMAILTEMPLATEGET = "EMAILTEMPLATEGET"
export const EMAILTEMPLATEDETAILS ="EMAILTEMPLATEDETAILS"
export const EMAILTEMPLATEUPDATE ="EMAILTEMPLATEUPDATE"